/* eslint-disable no-undef */
"use strict";

module.exports = function () {
    $(document).ready(function () {
        // Set the scroll amount
        var scrollAmount = 200; // Adjust this value as needed

        // Event handler for the left arrow
        $(".arrow-left").on("click", function () {
            $(".popular-categories-wrapper").animate({
                scrollLeft: "-=" + scrollAmount
            }, 300); // Adjust the duration as needed
        });

        // Event handler for the right arrow
        $(".arrow-right").on("click", function () {
            $(".popular-categories-wrapper").animate({
                scrollLeft: "+=" + scrollAmount
            }, 300); // Adjust the duration as needed
        });
    });
};
